import { render, staticRenderFns } from "./TradeWidgetResult.vue?vue&type=template&id=74d6cd25&scoped=true&"
import script from "./TradeWidgetResult.vue?vue&type=script&lang=js&"
export * from "./TradeWidgetResult.vue?vue&type=script&lang=js&"
import style0 from "./TradeWidgetResult.vue?vue&type=style&index=0&id=74d6cd25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6cd25",
  null
  
)

export default component.exports